// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"107fac38","882":"2c1e90cc"}[chunkId] + ".chunk.js";
};